<fieldset [attr.id]="question.id">
  <legend>
    <div [attr.aria-labelledby]=" question.id +'-err'"></div>
  </legend>
  @let title = text();
  @if (title) {
    <div id="{{ question.id }}-label-content" tabindex="0" class="focusable" [innerHTML]="title"></div>
  }

  @if (controlHasError()) {
    <div class="alert alert-danger error pill form-error-list">
      <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
        <ul>
          @for (err of baseForm.errorMap.get(question.id!); track err) {
            <li>
              <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
            </li>
          }
        </ul>
      </div>
    </div>
  }
  <!-- make sure aria attributes and other are configurable -->
  <div>
    <div class="buttons mt-6 mb-4 text-end">

      <button class="btn primary rounded-pill mt-3 me-3"
              #confirmButton
              [class.confirm-btn]="question.type === 'CONFIRM_OPTION'"
              [disabled]="baseForm.loading || baseForm.preventSave"
              [attr.aria-label]="displayValue(yesButton, buttonCode(yesButton)) + ', 1 of 2'"
              (click)="onValueChange(yesButton);onEnter($event)"
              (keydown.enter)="onValueChange(yesButton);onEnter($event)">
        @if (baseForm.loading) {
          <span class="spinner-border spinner-border-sm mr-1"></span>
        }
        {{ displayValue(yesButton, buttonCode(yesButton)) }}
      </button>

      @if (question.type === "CONFIRM_OPTION") {
        <button class="btn secondary rounded-pill btn-no confirm-btn mt-3"
                #notConfirmButton
                [disabled]="baseForm.loading || baseForm.preventSave"
                [attr.aria-label]="displayValue(noButton, buttonCode(noButton)) +', 2 of 2'"
                (click)="onValueChange(noButton);onEnter($event)"
                (keydown.enter)="onValueChange(noButton);onEnter($event)">
          @if (baseForm.loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{ displayValue(noButton, buttonCode(noButton)) }}
        </button>
      }

    </div>
  </div>

    @if (baseForm.isSubmitted(form) && !control.untouched) {
      <div #feedback class="feedback-icon form-group radio dropdown-feedback-icon" aria-hidden="true">
        <i class="fa" aria-hidden="true"
           [ngClass]="{ 'fa-check-circle' : !controlHasError(), 'fa-times-circle': controlHasError() }"></i>
      </div>
    }

  </fieldset>

<ng-content></ng-content>
